import { render, staticRenderFns } from "./LeagueTableEntry.vue?vue&type=template&id=f34e6acc&"
import script from "./LeagueTableEntry.vue?vue&type=script&lang=js&"
export * from "./LeagueTableEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports